export default __webpack_public_path__ + "static/media/AKGL.3c8d134d.png";